import React from 'react';
import { groupBy } from '../../../../../../../shared/lib/functional';
import { DailyProgramVenueMealPeriod } from '../../../../../../../shared/types/dailyProgram';
import Carousel from './Carousel';
import { SimilarTimes } from './hoc/SimilarTimesHoc';

interface OtherTimesPropsBase {
  similarTimes: SimilarTimes[];
}

type OtherTimesProps = OtherTimesPropsBase & React.HTMLProps<HTMLDivElement>;

function OtherTimes(props: OtherTimesProps) {
  const { className, similarTimes, ...rest } = props;

  const classes = [''];
  if (className) classes.push(className);

  function getMealPeriodGroups(mp: DailyProgramVenueMealPeriod[]) {
    const groups = groupBy(mp, 'name');

    const collections = Object.keys(groups).map(key => ({
      key,
      values: groups[key],
    }));

    return collections;
  }

  return (
    <Carousel {...rest} className={classes.join(' ')}>
      {similarTimes.map(st => (
        <div key={st.date} className="flex flex-col whitespace-nowrap cursor-default gap-1 mr-4">
          <div className="time-date">{st.date}</div>
          <div className="leading-snug time-availability">
            {st.times.map((t, i) => (
              <div key={i} className="font-semibold">
                {t}
              </div>
            ))}
          </div>
          {st.mealPeriods.length > 0 && (
            <div className="mt-4">
              {getMealPeriodGroups(st.mealPeriods).map((mp, i) => (
                <div key={i} className="flex-grow mt-1">
                  <div className="mealperiod-name font-semibold">{mp.key}</div>
                  <div className="leading-snug mealperiod-availability">
                    {mp.values.map((v, i) => (
                      <div key={i}>{v.timeString}</div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </Carousel>
  );
}

export default OtherTimes;
